/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_New_Reason_OutInputs */

const vi_sl_new_reason_out = /** @type {(inputs: Sl_New_Reason_OutInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lý do xuất`)
};

/**

* @param {Sl_New_Reason_OutInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_new_reason_out = /** @type {((inputs?: Sl_New_Reason_OutInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_New_Reason_OutInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_new_reason_out(inputs)
});